<template>
  <Column class="w-100b">
    <Row class="w-100b p-lr-16 p-t-16 p-b-12" x="sb">
      <span class="text-14px">{{ tiitle }}</span>
      <Row>
        <slot name="tiitleRight">
          <IconSvg name="icon-IconArrowLeft_Home" class="font-18 pointer m-r-5" :class="listStart == 0 ? 'c-lInfo' : 'c-border'" @click="listStartChange(-showNum)" />
          <IconSvg name="icon-IconArrowRight_Home" class="font-18 pointer" :class="(listStart + showNum) >= list.length ? 'c-lInfo' : 'c-border'" @click="listStartChange(showNum)" />
        </slot>
      </Row>
    </Row>
    <slot name="a1" />
    <Column class="w-100b" y="s">
      <Column v-if="list.length == 0" class="w-100b" y="s" x="c">
        <ListEmpty class="p-tb-25" :size="78" :text="$t('table.noResultsFound')" />
      </Column>
      <Row
        v-for="(item) in list.slice(listStart, listStart + showNum)"
        :key="item.coinName"
        class="w-100b p-lr-10 h-60 pointer bg-hover-lInfo"
        x="sb"
        y="c"
        @click="() => toFinancial(item)"
      >
        <Row class="" x="s" y="c">
          <span class="font-14 m-r-12" :class="item.sIndex <= 3 ? 'c-warning' : 'text-9b'">{{ item.sIndex }}</span>
          <el-image class="w-22 h-22 radius-50b m-r-8" :src="quotesStore.coinImageMap[item.coinName]">
            <template #placeholder>
              <el-image class="w-22 h-22 " :src="coinDefaultImage" />
            </template>
            <template #error>
              <el-image class="w-22 h-22 " :src="coinDefaultImage" />
            </template>
          </el-image>
          <Row class="font-14">
            <span class="font-w-700">{{ item.coinName }}</span>
          </Row>
        </Row>
        <Column y="e" x="e">
          <span class="font-14 font-w-700 c-success">{{ item.incomeRatio }}%</span>
          <span class="font-14 text-9b m-b-4">{{ $t('home.estAPR') }}</span>
        </Column>
      </Row>
    </Column>
  </Column>
</template>

<script setup>
import coinDefaultImage from '@/image/coinDefaultImage.webp'

const props = defineProps({
  showNum: {
    default: 3,
  },
  list: {},
  tiitle: {},
  runListEmpty: {
    default: true,
  },
  tabValue: {},
})
const quotesStore = useQuotesStore()

let listStart = $ref(0)
watch(
  () => props.tabValue,
  () => {
    listStart = 0
  }
)

const listStartChange = (n) => {
  if (n == -props.showNum && listStart != 0) {
    listStart += n
    return
  } else if (n == props.showNum && (listStart + props.showNum) < props.list.length) {
    listStart += n
    return
  }
}

const toFinancial = (item) => {
  router.push({
    path: '/financial',
    query: {
      coinId: item.coinId
    },
  })
}

onMounted(() => {

})

</script>

<style lang="scss">

.QuerySymbol{
  position: absolute;
  .QuerySymbol-input{
    .el-input__wrapper{
      padding-left: 38px !important;
      border-radius: 38px !important;
    }
    .el-input__inner{
      --el-input-height: 32px;
      font-size: 12px !important;
      height: 32px !important;
    }
    .el-input__inner::placeholder{
      font-size: 12px !important;
    }
  }
}
</style>
